interface CourierLevelInfo {
  level: number;
  title: string;
  desc: string;
  color: string;
  bg: string;
  border: string;
  badgeBg: string;
  badgeText: string;
}

export function OppCourierLevelCards({ levels }: { levels: CourierLevelInfo[] }) {
  return (
    <div className="grid grid-cols-2 gap-3">
      {levels.map((levelInfo) => (
        <div key={levelInfo.level} className={`rounded-xl ${levelInfo.bg} p-4 shadow-sm`}>
          <span
            className={`mb-1 inline-block rounded-full px-2 py-0.5 text-caption font-bold ${levelInfo.badgeBg} ${levelInfo.badgeText}`}
          >
            L{levelInfo.level}
          </span>
          <p className={`text-sm font-semibold ${levelInfo.color}`}>{levelInfo.title}</p>
          <p className={`mt-0.5 text-xs opacity-70 ${levelInfo.badgeText}`}>
            {levelInfo.desc}
          </p>
        </div>
      ))}
    </div>
  );
}
